import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiCopyright } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiApiCopyrightDialogData {
  copyrights?: ApiCopyright[];
}

@Component({
  selector: 'app-multi-copyright-dialog',
  templateUrl: './multi-copyright-dialog.component.html',
  styleUrls: ['./multi-copyright-dialog.component.css'],
  standalone: false,
})
export class MultiCopyrightDialogComponent implements OnInit {

  //コピーライト×言語数
  copyrights: ApiCopyright[] = [];
  copyrightsFormGroup!: FormGroup;
  copyrightsArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiCopyrightDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiApiCopyrightDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.copyrights = this.data.copyrights!;
    if (!this.copyrights) {
      this.copyrights = [];
    }
    this.createForm();
    this.copyrightsArrayControl = this.copyrightsFormGroup.get('copyrights') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.copyrightsFormGroup.disable();
    }
  }

  //コピーライトフォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.copyrights.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let copyright = '';
      let trans_copyright = '';
      for (const value of this.copyrights) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          copyright = value.copyright;
          trans_copyright = value.trans_copyright;
          break
        }
      }
      arrayControl.push(this.formBuilder.group(
        {
          autoTrans: [auto_trans],
          copyright: [copyright],
          transCopyright: [trans_copyright],
        }
      ));
      index++;
    }
    this.copyrightsFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        copyrights: arrayControl
      }
    );
  }

  //更新ボタン
  addCopyrights(): void {
    if (this.copyrightsFormGroup.valid) {
      let copyrights = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.copyrightsArrayControl.controls[index];
        copyrights.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            copyright: ctrl.get('copyright')!.value,
            trans_copyright: ctrl.get('transCopyright')!.value,
          }
        )
      }
      this.copyrights = copyrights;
      this.dialogRef.close(this.copyrights);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.copyrightsFormGroup.get('autoAllTrans')!.value;
    for (const copyright of this.copyrightsArrayControl.controls) {
      copyright.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.copyrightsArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const copyright of this.copyrightsArrayControl.controls) {
      if (!copyright.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.copyrightsFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
